import React from "react";
import "./styles.scss";
import {
  isSelfUsername,
  getUpdatedCurrentUser
} from "../../../../../api/helper";
import { ReactComponent as EditIcon } from "../../../../../public/icons/nav/edit.svg";
import { ReactComponent as AddIcon } from "../../../../../public/icons/add-icon.svg";
import DefaultPicture from "../../../../../public/images/default_picture.svg";
import ArtistProfileImagePicker from "./ArtistProfileImagePicker";
import ImageUploader from "../../../../shared/ImageUploader";
import { updateCurrentUser, updateCurrentUserBio } from "../../../../../api/users";
import store from "../../../../../redux/store";
import Actions from "../../../../../redux/actions";
import { createMedium } from "../../../../../api/media";
import Linkify from "linkifyjs/react";

export default class About extends React.Component {
  handleEditImages = () => {
    this.ArtistProfileImagePickerRef.current.click();
  };
  submitUserChanges = async ids => {
    await updateCurrentUser({
      user: {
        artist_profile: {
          images: ids
        }
      }
    });
    getUpdatedCurrentUser();
  };
  editImage = (index, imageId) => {
    let new_array = this.props.user.artist_profile.images.map(i => i.id);
    new_array[index] = imageId;
    this.submitUserChanges(new_array);
  };
  addImage = imageId => {
    let new_array = this.props.user.artist_profile.images.map(i => i.id);
    new_array.push(imageId);
    this.submitUserChanges(new_array);
  };
  icon_text = (Icon, text) => {
    return (
      <div className="d-flex flex-column mr-5">
        <Icon /> <span className="mt-2">{text}</span>
      </div>
    );
  };
  state = {
    editingBio: false,
    bio: this.props.user.artist_profile && this.props.user.artist_profile.bio,
    podcaster_bio: this.props.user && this.props.user.bio,
    prevBio: null
  };
  editBio = () => {
    this.setState({ prevBio: this.state.bio, editingBio: true });
  };


  saveBio = async () => {
    let {
      data: { user, meta }
    } = await updateCurrentUser({
      user: {
        artist_profile: {
          bio: this.state.bio
        }
      }
    });
    this.setState({ editingBio: false });
    store.dispatch(Actions.setCurrentUser(user, meta));
  };

  savePodcasterBio = async () => {
    let {
      data: { user, meta }
    } = await updateCurrentUserBio({
      user: {
        bio: this.state.podcaster_bio
      }
    });
    this.setState({ editingBio: false });
    store.dispatch(Actions.setCurrentUser(user, meta));
  };

  cancelBioSave = () => {
    this.setState({
      bio: this.state.prevBio,
      editingBio: false
    });
  };

  updateBio = ({ target: { value } }) => {

    // let bio_with_html_string = this.convertStringToHtml(value)

    // this.setState({ html_bio: bio_with_html_string })
    this.setState({ bio: value });
  }

  updatePodcasterBio = ({ target: { value } }) => {

    // let bio_with_html_string = this.convertStringToHtml(value)

    // this.setState({ html_bio: bio_with_html_string })
    this.setState({ podcaster_bio: value });
  }
  // convertStringToHtml=(string)=>{

  //   let bio_with_html_string
  //   let urlRegex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
  //   let new_text_with_link = string.replace(urlRegex, function (url) {
  //     let _url = (url.match(/^https?:/) || url.match(/^http?:/))? url : 'http://' + url;
  //     return '<a className="anchor-tag" target="_blank" href="' + _url + '">' + url + '</a>';
  //   })

  //   if (parseInt(this.state.bio?.search("<div>")) < 0) {

  //     new_text_with_link.replace("<div>", "")
  //     new_text_with_link.replace("</div>", "")
  //     bio_with_html_string = `<div>${new_text_with_link}</div>`
  //   } else {

  //     bio_with_html_string = `<div>${new_text_with_link}</div>`
  //   }

  //   return bio_with_html_string
  // }

  galleryRef = React.createRef();
  ArtistProfileImagePickerRef = React.createRef();

  renderImage = (isSelf, i) => (
    <>
      {isSelf && (
        <ImageUploader
          onSubmit={async s3_object_key => {
            let {
              data: { medium }
            } = await createMedium({
              media: {
                s3_object_key,
                type: "Image"
              }
            });
            if (this.props.user.artist_profile && this.props.user.artist_profile.images[i])
              this.editImage(i, medium.id);
            else this.addImage(medium.id);
          }}
        >
          {this.props.user.artist_profile && this.props.user.artist_profile.images[i] ? (
            <EditIcon className="edit" />
          ) : i === 0 ||
            (i === 1 && this.props.user.artist_profile && this.props.user.artist_profile.images[0]) ||
            (i === 2 && this.props.user.artist_profile &&
              this.props.user.artist_profile.images[0] &&
              this.props.user.artist_profile.images[1]) ? (
            <AddIcon className="edit" />
          ) : null}
        </ImageUploader>
      )}
      {this.props.user.artist_profile && this.props.user.artist_profile.images[i] ? (
        <img alt="" src={this.props.user.artist_profile.images[i].url} />
      ) : (
        <img alt="" src={DefaultPicture} />
      )}
    </>
  );

  render() {
    // let hrml_string = this.state.bio && this.convertStringToHtml(this.state.bio)
    console.log(this.props.user.artist_profile && this.props.user.artist_profile.images.map(i => i.id));
    let isSelf = isSelfUsername(this.props.user.username);
    return (
      <div id="artist_about" className="container-fluid my-4 text-primary">
        <div id="artist_gallary" className="row no-gutters">
          <div className="col-66 img-container">
            {this.renderImage(isSelf, 0)}
          </div>
          <div className="col-33">
            <div className="img-container">{this.renderImage(isSelf, 1)}</div>
            <div className="img-container">{this.renderImage(isSelf, 2)}</div>
          </div>
        </div>

        {this.props.user.user_type == "podcaster" ? (
          <div id="artist_bio">
            {this.state.editingBio ? (
              <div className="text-right">
                <textarea
                  className="form-control w-100"
                  value={this.state.podcaster_bio}
                  onChange={this.updatePodcasterBio}
                  placeholder="Tell the world about you by entering your bio here!"
                  rows="7"
                />
                <div className="d-flex justify-content-end">
                  <button
                    onClick={this.savePodcasterBio}
                    className="btn btn-sm btn-primary mt-2 mr-2"
                  >
                    Save
                  </button>
                  <button
                    onClick={this.cancelBioSave}
                    className="btn btn-sm btn-primary mt-2"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            ) : (
              <div style={{ fontSize: 18 }}>
                {this.state.podcaster_bio && this.state.podcaster_bio.length ? (
                  <Linkify tagName="pre">{this.state.podcaster_bio}</Linkify>
                ) : (
                  <span className="text-muted">Podcaster Biography</span>
                )}
                {isSelf && <EditIcon className="edit" onClick={this.editBio} />}
              </div>
            )}
          </div>
        ) : (
          <div id="artist_bio">
            {this.state.editingBio ? (
              <div className="text-right">
                <textarea
                  className="form-control w-100"
                  value={this.state.bio}
                  onChange={this.updateBio}
                  placeholder="Tell the world about you by entering your bio here!"
                  rows="7"
                />
                <div className="d-flex justify-content-end">
                  <button
                    onClick={this.saveBio}
                    className="btn btn-sm btn-primary mt-2 mr-2"
                  >
                    Save
                  </button>
                  <button
                    onClick={this.cancelBioSave}
                    className="btn btn-sm btn-primary mt-2"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            ) : (
              <div style={{ fontSize: 18 }}>
                {this.state.bio && this.state.bio.length ? (
                  <Linkify tagName="pre">{this.state.bio}</Linkify>
                ) : (
                  <span className="text-muted">Artist Biography</span>
                )}
                {isSelf && <EditIcon className="edit" onClick={this.editBio} />}
              </div>
            )}
          </div>
        )}

        <ArtistProfileImagePicker
          onSubmit={async ids => {
            await updateCurrentUser({
              user: {
                artist_profile: {
                  images: ids
                }
              }
            });
            getUpdatedCurrentUser();
          }}
        >
          <span ref={this.ArtistProfileImagePickerRef} />
        </ArtistProfileImagePicker>
      </div>
    );
  }
}
